import React, { useContext } from 'react';
import SimpleContext from './../../context/SimpleContext';
import './SimpleProduct.css'
import SimplePro from './SimplePro';

const SimpleProduct = () => {

    const context = useContext(SimpleContext);
 

    return ( 
        <div className="SimplePMain">
        {
                context.SimplePrd.length?
                context.SimplePrd.map((inf,i)=> 
                    <SimplePro key={i}
                    category={inf.category}
                    slug={inf.slug}
                    name={inf.name}
                    price={inf.price}
                    Discount_Price={inf.Discount_Price}
                    user_price={inf.user_price}
                    unit={inf.unit}
                    numSale={inf.number_in_sale}
                    numUnit={inf.number_in_unit}
                    min={inf.minimum}
                    ULImg={inf.ULImg}
                    max={inf.maximum}
                    unique_id={inf.unique_id}
                    goodsRef={inf.goods_ref}
                    Role={inf.Role}
                    sahmie_bandi={inf.sahmie_bandi}
                    />
                ):null
            }
        </div> 
    );
}
 
export default React.memo(SimpleProduct);
